import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Rollbar from "rollbar";

import { ErrorMessagePage } from "components/MessagePage";
import Translate from "utils/translate";

const { t } = new Translate("ErrorBoundary");

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };

    if (env !== "development") {
      this.state.rollbar = new Rollbar({
        accessToken: rollbarKey,
        captureUncaught: true,
        captureUnhandledRejections: true,
      });
      this.state.rollbar.configure({ payload: { environment: env } });
    }
  }

  componentWillReceiveProps({ userId }) {
    if (userId && this.state.rollbar) {
      this.state.rollbar.configure({ payload: { person: { id: userId } } });
    }
  }

  componentDidCatch(error) {
    this.setState({ hasError: true });
    if (window.Intercom) window.Intercom("showNewMessage");
    if (env !== "development") this.state.rollbar.error(error);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) return <ErrorMessagePage message={t("message")} title={t("title")} />;

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  userId: PropTypes.number,
};

const mapStateToProps = ({ currentUser }) => ({
  userId: currentUser.id,
});

export default withRouter(connect(mapStateToProps)(ErrorBoundary));
